var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLogin
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [
          _c("router-view"),
          _vm._v(" "),
          !_vm.isOffline
            ? _c(
                "div",
                [
                  !_vm.isOffline
                    ? _c(
                        "el-dialog",
                        {
                          staticClass: "showBindWxDialog",
                          attrs: { visible: _vm.showBindWx },
                          on: {
                            "update:visible": function($event) {
                              _vm.showBindWx = $event
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "qccontent",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _c(
                                "h2",
                                { staticStyle: { "margin-top": "0px" } },
                                [_vm._v("获取微信项目进度提醒")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticStyle: { "margin-bottom": "50px" } },
                                [
                                  _vm._v(
                                    "\n          请进行以下操作以获取项目进度提醒，提醒将在每日10：00以微信消息形式推送，并支持对项目进行打分和反馈。\n        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "180px",
                                    height: "180px",
                                    margin: "auto"
                                  }
                                },
                                [
                                  _c("div", {
                                    ref: "qrcode",
                                    attrs: { id: "qrcode" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "margin-top": "15px",
                                    "margin-bottom": "0px"
                                  }
                                },
                                [_vm._v("使用微信扫描此二维码")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticStyle: { "margin-top": "0px" } },
                                [_vm._v("将龙猫ID与您的微信绑定")]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isOffline
                    ? _c(
                        "el-dialog",
                        {
                          staticClass: "showBindWxDialog",
                          attrs: { visible: _vm.showBindConcernWx },
                          on: {
                            "update:visible": function($event) {
                              _vm.showBindConcernWx = $event
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "qccontent",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _c(
                                "h2",
                                { staticStyle: { "margin-top": "0px" } },
                                [_vm._v("获取微信项目进度提醒")]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("\n          请使用当前绑定的微信号("),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "22px",
                                      "font-weight": "800"
                                    }
                                  },
                                  [_vm._v(_vm._s(this.wxNick))]
                                ),
                                _vm._v(
                                  ")扫描下方二维码或直接搜索关注“龙猫数据客户服务”公众号，即可每天早10：00收取最新项目进度提醒，并可对项目进行反馈。\n        "
                                )
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                staticStyle: {
                                  width: "180px",
                                  height: "180px",
                                  margin: "auto"
                                },
                                attrs: { src: "/static/customer_service.png" }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "qc-line" }),
                              _vm._v(" "),
                              _c("p", { staticStyle: { color: "#5e6678" } }, [
                                _vm._v(
                                  "\n          如需更换绑定的微信号，使用新微信号扫描下方二维码换绑即可\n        "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "180px",
                                    height: "180px",
                                    margin: "auto"
                                  }
                                },
                                [_c("div", { attrs: { id: "qrcodeConcern" } })]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 